import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { StageAccessService } from '../access/stage-access.service';

/** Keeps the staging SPA behind the tester allowlist. Production builds bypass
 * this guard; Firestore rules provide the corresponding server-side check. */
export const stageAccessGuard: CanActivateFn = (_route, state) => {
  if (!environment.staging) return true;

  const authService = inject(AuthService);
  const stageAccess = inject(StageAccessService);
  const router = inject(Router);

  return stageAccess.isLocked().pipe(
    switchMap(locked => {
      if (!locked) return [true];

      return authService.user$.pipe(
        take(1),
        switchMap(user => {
          if (!user) {
            return [router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } })];
          }
          if (user.role === 'super_admin') return [true];

          return stageAccess.hasAccess(user.uid).pipe(
            map(allowed => allowed || router.createUrlTree(['/stage-access-denied']))
          );
        })
      );
    })
  );
};
